import { render, staticRenderFns } from "./InventoryAlert.vue?vue&type=template&id=2a0b46b6&scoped=true"
import script from "./InventoryAlert.vue?vue&type=script&lang=js"
export * from "./InventoryAlert.vue?vue&type=script&lang=js"
import style0 from "./InventoryAlert.vue?vue&type=style&index=0&id=2a0b46b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0b46b6",
  null
  
)

export default component.exports